import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';

import { programCategoryList } from '@/network/apis/apiUri';
import NAV from '@/config/data/nav/nav_data.json';

export default function NewsNav() {
  const { news, mode } = useSelector((state) => state);

  const { data, isSuccess } = useQuery({
    queryKey: ['news', 'nav', mode],
    queryFn: async () => {
      const response = await programCategoryList({
        lan_code: mode,
        program_type: 'news',
        classify: 'content',
        is_open_allow: true,
      });

      return { items: response.data.item };
    },
  });

  return (
    <div className="news-header__nav-container">
      <div className="news-header__nav">
        <ul className="news-header__list">
          {isSuccess &&
            data.items.map((data) => (
              <li className="news-header__item" key={`category_${data.category_id}`}>
                <Link
                  to={`${NAV['NEWS_GENRE'].path}?category=${encodeURIComponent(data.title)}`}
                  className="news-header__item__button"
                  data-active={news.category === data.title}
                >
                  {data.title}
                </Link>
              </li>
            ))}
        </ul>
        <a
          href={`https://company.arirang.com/join/videotip?lang=${mode}`}
          target="_blank"
          rel="noreferrer"
          title={'Opens in a new window'}
        >
          <img
            src={require('@/assets/images/news/header/video-submission.png').default}
            alt="Video Submission동영상 제보 바로가기"
            width={66}
            height={57}
          />
        </a>
      </div>
    </div>
  );
}
